import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { TournamentProvider } from './context/TournamentContext';
import HomePage from './components/HomePage'; // Create this component
import CreateTournament from './components/TournamentForm'; // Assuming TournamentForm is your create tournament page
import FetchTournaments from './components/TournamentList'; // Assuming TournamentList is for fetching tournaments
import Login from './components/loginPage';
import WithdrawRequest from './components/WithdrawRequest'
import UserWallet from './components/UserWallet'


const ProtectedRoute = ({ element, ...rest }) => {
  const accessToken = localStorage.getItem('accessToken');
  console.log("ENV API URL:", process.env.REACT_APP_API_URL);

  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  return element;
};


const App = () => {
  return (
    <TournamentProvider>
      <Router>
        <div style={{ padding: '20px' }}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Dashboard" element={<ProtectedRoute element={<HomePage />} />} />
            <Route path="/create-tournament" element={<CreateTournament />} />
            <Route path="/fetch-tournaments" element={<FetchTournaments />} />
            <Route path="/withdraw-request" element={<WithdrawRequest />} />
            <Route path="/user-wallet" element={<UserWallet />} />
          </Routes>
        </div>
      </Router>
    </TournamentProvider>
  );
};

export default App;
